<template>
  <div class="project-info app-panel blank-v blank-h">
    <el-form class="max-width" ref="form" :model="form" :rules="rules" :label-width="labelWidth">
      <el-form-item label="项目名称" prop="name" v-if="id">
        <p>{{form.name}}</p>
      </el-form-item>
      <el-form-item label="项目名称" prop="name" v-else>
        <el-select v-model="form.name" placeholder="请选择项目" filterable>
          <el-option v-for="(value, index) in nameOptions" :key="index" :label="value.project_second_party_name" :value="value.project_second_party_code"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="明源项目" prop="projectName" v-if="id">
        <p>{{form.projectName}}</p>
      </el-form-item>
      <el-form-item label="明源项目" prop="projectName" v-else>
        <el-select v-model="form.projectName" placeholder="请选择明源项目" filterable>
          <el-option v-for="(value, index) in projectNameOptions" :key="index" :label="value.proj_name" :value="value.proj_guid"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="所在地" prop="china">
        <el-cascader
          ref="cascader"
          placeholder="请选择所在地"
          :options="chinaOptions"
          filterable
          :props="props"
          v-model="form.china"
          clearable
          @change="changeChina"
        >
        </el-cascader>
      </el-form-item>
      <el-form-item label="案场地址" prop="address">
        <el-input placeholder="请输入案场地址" v-model="form.address" clearable></el-input>
      </el-form-item>
      <el-form-item label="拾取坐标" prop="pos">
        <tencent-map :city="city" v-model="form.pos"></tencent-map>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submit">确定</el-button>
        <el-button @click="cancel">取消</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>;
  import CommonService from '@/io/common.js';
  import ProjectService from '@/io/project.js';
  import TencentMap from '@/components/TencentMap.vue';

  export default {
    name: 'ProjectInfo',
    watch: {
      id: {
        handler(newValue, oldValue) {
          Promise.all(
            [
              this.initChinaOptions(),
              this.initProjectOptions(),
              this.initMYProjectOptions()
            ]
          ).then(res => {
            if (newValue) {
              this.initDatas();
            }
          }).catch(() => {})
        },
        immediate: true
      }
    },
    data() {
      return {
        id: this.$route.params.id,
        form: {
          name: '',
          projectName: '',
          china: [],
          address: '',
          pos: null
        },
        rules: {
          name: [
            {
              required: true, message: '请选择项目名称'
            },
            {
              validator(rule, value, callback) {
                ProjectService.extraProjectIsUsed(value).then(res => {
                  if (res.status) {
                    callback(new Error('该项目已被使用'));
                  } else {
                    callback();                
                  }
                }).catch(() => {});
              }
            }
          ],
          projectName: [
            {
              required: true, message: '请选择项目名称'
            }
          ],
          china: [
            {
              required: true, message: '请选择所在地'
            }
          ],
          address: [
            {
              required: true, message: '请输入案场地址'
            }
          ],
          // pos: [
          //   {
          //     required: true, message: '请选择拾取坐标'
          //   }
          // ]
        },
        nameOptions: [],
        projectNameOptions: [],
        chinaOptions: [],
        city: '',
        props: {
          value: 'system_area_id',
          children: '_child',
          label: 'system_area_name'
        },
      }
    },
    components: {
      TencentMap,
    },
    methods: {
      initDatas() {
        ProjectService.info(this.id).then(res => {
          let arr = [];
          if (res.data.attr_data.city_area_id) {
            arr.push(res.data.attr_data.city_area_id);
          }
          if (res.data.attr_data.province_area_id) {
            arr.push(res.data.attr_data.province_area_id);
          }
          if (res.data.attr_data.district_area_id) {
            arr.push(res.data.attr_data.district_area_id);
          }
          this.form.china = arr;
          this.form.name = res.data.attr_data.project_attr_name;
          this.form.projectName = res.data.attr_data.mingyuan_project_name;
          this.form.address = res.data.attr_data.project_attr_address;
          this.form.pos = {
            lat: res.data.attr_data.project_attr_lat,
            lng: res.data.attr_data.project_attr_lng
          };

        }).catch(() => {});
      },
      initChinaOptions() {
        if (this.$store.state.china) {
          return new Promise((resolve, reject) => {
            this.chinaOptions = this.$store.state.china;
            resolve();
          });
        } else {
          return CommonService.china().then(res => {
            this.chinaOptions = res.data;
            this.$store.commit('setChina', res.data);
          }).catch(() => {});
        }
      },
      initProjectOptions() {
        return ProjectService.extraProjectList().then(res => {
          this.nameOptions = res.data;
        }).catch(() => {});
      },
      initMYProjectOptions() {
        return ProjectService.MYProjectList().then(res => {
          this.projectNameOptions = res.data;
        }).catch(() => {});
      },
      changeChina() {
        let arr = [];
        this.depthSearchTree(
          node => {
            arr.push(node.data.system_area_name);
          },
          this.$refs.cascader.getCheckedNodes(),
          'parent'
        );
        this.city = arr.reverse()[0];
      },
      submit() {
        this.$refs.form.validate(valid => {
          if (valid) {
            if (this.id) {
              ProjectService.edit(
                this.id,
                this.form.china[0] ? this.form.china[0] : '',
                this.form.china[1] ? this.form.china[1] : '',
                this.form.china[2] ? this.form.china[2] : '',
                this.form.address,
                this.form.pos.lat,
                this.form.pos.lng
              ).then(() => {
                this.$message.success('编辑成功');
                this.cancel();
              }).catch(() => {});
            } else {
              let obj;
              this.nameOptions.forEach(val => {
                if (val.project_second_party_code === this.form.name) {
                  obj = val;
                }
              });
              ProjectService.add(
                obj.project_second_party_name,
                obj.project_second_party_code,
                this.form.projectName,
                this.form.china[0] ? this.form.china[0] : '',
                this.form.china[1] ? this.form.china[1] : '',
                this.form.china[2] ? this.form.china[2] : '',
                this.form.address,
                this.form.pos.lat,
                this.form.pos.lng
              ).then(() => {
                this.$message.success('创建成功');
                this.cancel();
              }).catch(() => {});
            }
          }
        });
      },
      cancel() {
        this.$router.push({
          path: '/project_manage'
        });
      }
    },
  }
</script>

<style lang="less" scoped>

</style>